<template>
  <a class="ed-btn-squared" :href="href" :disabled="disabled" :target="target" :rel="newRel" v-if="href">
    <slot></slot>
    <span class="ed-btn-squared__notification" v-if="notification">
      {{ notification }}
    </span>
  </a>
  <button class="ed-btn-squared" :type="type" :disabled="disabled" v-else>
    <slot></slot>
    <span class="ed-btn-squared__notification" v-if="notification">
      {{ notification }}
    </span>
  </button>
</template>

<script>
  export default {
    name: 'SquaredButton',
    props: {
      href: String,
      target: String,
      rel: String,
      type: {
        type: String,
        default: 'button',
      },
      disabled: Boolean,
      notification: String,
    },
    computed: {
      newRel() {
        if (this.target === '_blank') {
          return this.rel || 'noopener';
        }
        return this.rel;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// squaredButton.vue?08dae5e5